export default __webpack_public_path__ + "static/logo_mairie17-861033379470af5fb33705fc6ff25d6b.png";